/**
 * Düz metin özetleri için HTML varlıklarını çözümler (`dangerouslySetInnerHTML` yoksa).
 * `&#…;` / `&#x…;` tüm Unicode’u kapsar; isimliler yalnızca sık görülenler (Word/CMS + TR).
 */
export function decodeHtmlEntitiesPlain(text: string): string {
    if (!text) return text;
    let s = text.split("&amp;").join("\uFFF0AMP\uFFF0");
    s = s.replace(/&#x([0-9a-f]{1,6});/gi, (match, hex: string) => {
        const cp = parseInt(hex, 16);
        if (!Number.isFinite(cp) || cp < 0 || cp > 0x10_ffff) return match;
        try {
            return String.fromCodePoint(cp);
        } catch {
            return match;
        }
    });
    s = s.replace(/&#(\d{1,7});/g, (match, dec: string) => {
        const cp = parseInt(dec, 10);
        if (!Number.isFinite(cp) || cp < 0 || cp > 0x10_ffff) return match;
        try {
            return String.fromCodePoint(cp);
        } catch {
            return match;
        }
    });
    const named: Record<string, string> = {
        nbsp: " ",
        lt: "<",
        gt: ">",
        quot: '"',
        apos: "'",
        ccedil: "ç",
        Ccedil: "Ç",
        scedil: "ş",
        Scedil: "Ş",
        gbreve: "ğ",
        Gbreve: "Ğ",
        Idot: "İ",
        inodot: "ı",
        ouml: "ö",
        Ouml: "Ö",
        uuml: "ü",
        Uuml: "Ü",
        auml: "ä",
        Auml: "Ä",
        eacute: "é",
        Eacute: "É",
        agrave: "à",
        Agrave: "À",
        aacute: "á",
        Aacute: "Á",
        iacute: "í",
        Iacute: "Í",
        oacute: "ó",
        Oacute: "Ó",
        uacute: "ú",
        Uacute: "Ú",
        szlig: "ß",
        ndash: "–",
        mdash: "—",
        hellip: "…",
        ldquo: "\u201c",
        rdquo: "\u201d",
        lsquo: "\u2018",
        rsquo: "\u2019",
        bull: "•",
        deg: "°",
        pound: "£",
        euro: "€",
        copy: "©",
        reg: "®",
        trade: "™",
    };
    s = s.replace(/&([a-zA-Z][a-zA-Z0-9]*);/g, (full, name: string) => {
        if (named[name] !== undefined) return named[name];
        const lower = name.toLowerCase();
        if (named[lower] !== undefined) return named[lower];
        return full;
    });
    return s.split("\uFFF0AMP\uFFF0").join("&");
}
